import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function HeroSection() {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/df6d94e8cecb0ead764bcc0aade5a457/e60e2bfe635517496d1e3df3c7578b50.png"
          alt="European institutional building at golden hour"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-navy-dark/92 via-navy-dark/70 to-navy/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy-dark/60 via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative w-full px-6 md:px-16 lg:px-24 pt-20">
        <div className="max-w-2xl">
          <div
            className={`transition-all duration-700 delay-100 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
            }`}
          >
            <span className="text-xs uppercase tracking-widest text-gold font-medium mb-5 block">
              {t("hero.label")}
            </span>
          </div>

          <div
            className={`transition-all duration-700 delay-200 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
            }`}
          >
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
              {t("hero.title1")}
              <span className="block text-gold mt-1">{t("hero.title2")}</span>
            </h1>
          </div>

          <div
            className={`transition-all duration-700 delay-300 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
            }`}
          >
            <p className="text-base md:text-lg text-white/75 leading-relaxed mb-10 max-w-xl">
              {t("hero.subtitle")}
            </p>
          </div>

          <div
            className={`flex flex-col sm:flex-row gap-4 transition-all duration-700 delay-400 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
            }`}
          >
            <Link
              to="/partner-registration"
              className="inline-block px-8 py-3.5 bg-gold text-white font-semibold text-sm rounded-md hover:bg-gold-light transition-colors duration-200 whitespace-nowrap cursor-pointer text-center"
            >
              {t("hero.cta1")}
            </Link>
            <Link
              to="/services"
              className="inline-block px-8 py-3.5 bg-white/10 text-white font-semibold text-sm rounded-md border border-white/30 hover:bg-white/20 transition-colors duration-200 whitespace-nowrap cursor-pointer text-center"
            >
              {t("hero.cta2")}
            </Link>
          </div>
        </div>
      </div>

      <div
        className={`absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 transition-all duration-700 delay-700 ${
          visible ? "opacity-100" : "opacity-0"
        }`}
      >
        <span className="text-white/40 text-xs uppercase tracking-widest">{t("hero.scroll")}</span>
        <div className="w-px h-8 bg-gradient-to-b from-white/30 to-transparent" />
      </div>
    </section>
  );
}
